import BaseModel from "./BaseModel";
import { formatDate } from "@/lib/date";

export class DeliveryPrintLog extends BaseModel {
  /* eslint-disable-next-line */
  constructor(props) {
    super(props);
  }

  get logWriter() {
    return this.writer?.realname || "";
  }

  renderCreatedAt(dateFormat = "yyyy-MM-dd HH:mm") {
    if (this.createdAt) {
      return formatDate(new Date(this.createdAt), dateFormat);
    } else {
      return "";
    }
  }

  renderPlatform() {
    switch (this.platform) {
      case "admin":
        if (this.writer?.authority === 1) {
          return "메인관제";
        } else {
          return "서브관제";
        }
      case "partner-web":
        return "파트너웹";
      default:
        return "";
    }
  }
}
